import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import KeyBox from './KeyBox';

import '../styles/Modal.css';

class Modal extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    modalInfo: PropTypes.shape({
      element: PropTypes.element.isRequired
    }),
    onClickClose: PropTypes.func
  }

  render() {
    const { modalInfo } = this.props;

    if (!modalInfo) {
      return null;
    }

    return (
      <KeyBox
        onPressESC={this._onClickCloseBtn}>
        <div className={classnames('Modal', this.props.className)}>
          <div
            className="Modal-closeBtn"
            onClick={this._onClickCloseBtn}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
              <path fill="#FFF" d="M6,4.93933983 L0.530330086,-0.530330086 C0.237436867,-0.823223305 -0.237436867,-0.823223305 -0.530330086,-0.530330086 C-0.823223305,-0.237436867 -0.823223305,0.237436867 -0.530330086,0.530330086 L4.93933983,6 L-0.530330086,11.4696699 C-0.823223305,11.7625631 -0.823223305,12.2374369 -0.530330086,12.5303301 C-0.237436867,12.8232233 0.237436867,12.8232233 0.530330086,12.5303301 L6,7.06066017 L11.4696699,12.5303301 C11.7625631,12.8232233 12.2374369,12.8232233 12.5303301,12.5303301 C12.8232233,12.2374369 12.8232233,11.7625631 12.5303301,11.4696699 L7.06066017,6 L12.5303301,0.530330086 C12.8232233,0.237436867 12.8232233,-0.237436867 12.5303301,-0.530330086 C12.2374369,-0.823223305 11.7625631,-0.823223305 11.4696699,-0.530330086 L6,4.93933983 Z" transform="translate(1 1)"/>
            </svg>
          </div>
          {
            React.cloneElement(modalInfo.element, {
              className: classnames('Modal-element', modalInfo.element.props.className)
            })
          }
        </div>
      </KeyBox>
    );
  }

  _onClickCloseBtn = () => {
    this.props.onClickClose();
  };

}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js